// icon
import { IconHome, IconPencil, IconPhoneCalling, IconFileDescription, IconSearch, IconCategory, IconCirclePercentage, IconNews } from "@tabler/icons-react";
// components
import Home from "../../pages/home/home";
import Detail from "../../pages/detail/Detail";
import ContactUs from "../../pages/contactUs/contactUs";
import AboutUs from "../../pages/aboutUs/aboutUs";
import Products from "../../pages/products/products";
import Discount from "../../pages/discount/discount";
import Blog from "../../pages/blog/blog";
import CategoryBlogPage from "../../pages/blog/pages/categoryBlog";
import CategoryDetail from "../../pages/blog/pages/blogDetail";


export const RoutesClient = [
    {
        show: false,
        mobileShow: true,
        child: false,
        label: 'خانه',
        address: '/',
        component: <Home />,
        icon: <IconHome />,
    },
    {
        show: false,
        mobileShow: true,
        child: true,
        label: 'دسته بندی',
        toggle: 'modal',
        address: '#collapse-menu',
        mobaddress: '#modal-menu',
        component: <Products />,
        icon: <IconCategory />,
    },
    {
        show: false,
        mobileShow: true,
        child: true,
        label: 'جست و جو',
        toggle: 'modal',
        address: '#collapse-menu',
        mobaddress: '#modal-search-mobile',
        component: <Products />,
        icon: <IconSearch />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        showIcon: true,
        label: 'تخفیف ها',
        footer: true,
        address: '/discount',
        component: <Discount />,
        icon: <IconCirclePercentage />,
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: true,
        label: 'درباره ما',
        address: '/about',
        component: <AboutUs />,
        icon: <IconPencil />,
    },
    {
        show: true,
        mobileShow: true,
        child: false,
        label: 'ارتباط باما',
        footer: true,
        address: '/contact',
        component: <ContactUs />,
        icon: <IconPhoneCalling />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: 'توضیحات محصول',
        address: '/items/detail/:id',
        component: <Detail />,
        icon: <IconFileDescription />
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        label: ' بر اساس دسته بندی',
        address: '/categories/:slug',
        component: <Products />,
        icon: <IconFileDescription />
    },
    {
        show: true,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله آریا استیل',
        address: '/blog',
        component: <Blog />,
        icon: <IconNews />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله آریا استیل',
        address: '/blog/categories/:slug',
        component: <CategoryBlogPage />,
        icon: <IconNews />,
    },
    {
        show: false,
        mobileShow: false,
        child: false,
        footer: false,
        label: 'مجله آریا استیل',
        address: '/blog/detail/:slug',
        component: <CategoryDetail />,
        icon: <IconNews />,
    },
]